import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

function Organizer() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - International Scientific Committee</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">Committee</Link></li>
            <li class="breadcrumb-item active" aria-current="page">InternationalCommittee</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">International Scientific Committee</H2>
                  <div className="text-dark-200 text-dark-200 w-full mr-auto text-left" style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                      <p>
                      <b>Professor Dr Mario Köppen </b><br/>
                      <i>Kyutech Institute of Technology, Japan</i><br/><br/>

                      <b>Professor Dr. Sri Hartati</b><br/>
                      <i>Universitas Gadjah Mada, Indonesia</i><br/><br/>

                      <b>Professor Dr Chidchanok Lursinsap</b><br/>
                      <i>Chulalongkorn University, Thailand</i><br/><br/>

                      <b>Professor Dr. Hizir Sofyan</b><br/>
                      <i>Syiah Kuala University, Indonesia</i><br/><br/>

                      <b>Professor Dr Ruhana Ku Mahamud</b><br/>
                      <i>Universiti Utara Malaysia, Malaysia</i><br/><br/>

                      <b>Professor Dr Nur Iriawan</b><br/>
                      <i>Institut Teknologi Sepuluh Nopember, Surabaya, Indonesia</i><br/><br/>

                      <b>Associate Professor Dr. Rajalida Lipikorn</b><br/>
                      <i>Chulalongkorn University, Thailand</i><br/><br/>

                      <b>Associate Professor Dr. Agus Harjoko</b><br/>
                      <i>Universitas Gadjah Mada, Indonesia</i><br/><br/>

                      <b>Professor Dr. Min Chen</b><br/>
                      <i>University of Oxford, England</i><br/><br/>

                      <b>Associate Professor Dr. Simon Fong</b><br/>
                      <i>University of Macau, China</i><br/><br/>

                      <b>Professor Dr. Mohammed Bennamoun</b><br/>
                      <i>University of Western Australia, Australia</i><br/><br/>

                      <b>Associate Professor Dr. Yasue Mitsukura</b><br/>
                      <i>Keio University, Japan</i><br/><br/>

                      <b>Professor Dr. Dhiya Al-Jumeily</b><br/>
                      <i>Liverpool John Moores University, UK</i><br/><br/>

                      <b>Professor Dr. Dariusz Krol</b><br/>
                      <i>Wroclaw University of Poland, Poland</i><br/><br/>

                      <b>Professor Dr. Richard Weber</b><br/>
                      <i>University of Chile, Santiago, Chile</i><br/><br/>

                      <b>Professor Dr. Jose Maria Pena</b><br/>
                      <i>Technical University of Madrid, Madrid, Spain</i><br/><br/>

                      <b>Associate Professor Yusuke Nojima</b><br/>
                      <i>Osaka Prefecture University, Japan</i><br/><br/>

                      <b>Dr. Siddhivinayak Kulkarni</b><br/>
                      <i>University of Ballarat, Australia</i><br/><br/>

                      <b>Professor Dr. Tahir Ahmad</b><br/>
                      <i>Universiti Teknologi Malaysia, Malaysia</i><br/><br/>

                      <b>Professor Dr. Daud Mohamed</b><br/>
                      <i>Universiti Teknologi MARA, Malaysia</i><br/><br/>

                      <b>Associate Professor Dr. Wahyu Wibowo</b><br/>
                      <i>Institut Teknologi Sepuluh Nopember, Surabaya, Indonesia</i><br/><br/>

                      <b>Associate Professor Dr. Edi Winarko</b><br/>
                      <i>Universitas Gadjah Mada, Indonesia</i><br/><br/>

                      <b>Associate Professor Dr. Retantyo Wardoyo</b><br/>
                      <i>Universitas Gadjah Mada, Indonesia</i><br/><br/>

                      <b>Associate Professor Dr. Rayner Alfred</b><br/>
                      <i>Universiti Malaysia Sabah, Malaysia</i><br/><br/>

                      <b>Associate Professor Dr. Faiz Ahmed Mohamed Elfaki</b><br/>
                      <i>Qatar University, Qatar</i><br/><br/>

                      <b>Associate Professor Dr Mohamed Chaouch</b><br/>
                      <i>Qatar University, Qatar</i><br/><br/>

                      <b>Dr. Abdul Haris Rangkuti, S</b><br/>
                      <i>BINUS University, Indonesia</i><br/><br/>

                      <b>Professor Dr. Eisuke Kita</b><br/>
                      <i>Nagoya University, Japan</i><br/><br/>

                      <b>Associate Professor Dr Waheb Abdullah Abduljabbar Shaif</b><br/>
                      <i>Birmingham City University, UK</i><br/><br/>

                      <b>Dr. Achmad Choiruddin</b><br/>
                      <i>Institut Teknologi Sepuluh Nopember, Surabaya, Indonesia</i><br/><br/>

                      <b>Dr. Jerry Dwi Purnomo</b><br/>
                      <i>Institut Teknologi Sepuluh Nopember, Surabaya, Indonesia</i><br/><br/>
                      </p>
                      </div>
              </div>
          </div>

  </div>
    );
}

export default Organizer;